import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
	selector: 'app-migration-notification-modal',
	templateUrl: './migration-notification-modal.component.html',
	styleUrls: ['./migration-notification-modal.component.scss'],
})
export class MigrationNotificationModalComponent {
	/* The modal title */
	title: string;

	/* The text of the button */
	button1: string;

	/* The width of the modal */
	modalwidth: any;

	/* Text content of the modal */
	content: string;

	/* The migration status of the user */
	migrationStatus: string;

	constructor(
		private dialogRef: MatDialogRef<MigrationNotificationModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private matDialogModule: MatDialogModule
	) {
		this.title = this.data && this.data.title;
		this.button1 = this.data && this.data.button1;
		this.modalwidth = this.data && this.data.modalwidth;
		this.content = this.data && this.data.content;
		this.migrationStatus = this.data && this.data.migrationStatus;
	}

	/*
	 *  This is called when the user hits the button and the modal will close
	 */
	submit() {
		const output = { value: 'submit' };
		this.dialogRef.close(output);
	}
}
